import { axios } from '../lib/axios';
import buildRequest from '../services/apis/buildRequest';

export function dataResponse({
  success = true,
  statusCode = 200,
  message = '',
  error = '',
  data = [],
}) {
  return {
    success,
    statusCode,
    message,
    error,
    data,
  };
}

export function handleError(error) {
  return dataResponse({
    statusCode: error.response?.status || error.response?.data?.statusCode || 500,
    message: error.response?.data?.message || error.response?.data?.mensaje || 'Error desconocido',
    error: error.response?.data?.error ||  'Error desconocido',
    success: false,
  });
}

export async function getApiRequest({ url, params }) {
  try {
    const { status, data } = await axios.get(url, buildRequest(params));
    return dataResponse({ data: data.data, statusCode: status });
  } catch (error) {
    return handleError(error);
  }
}
